import React, { useState, PropsWithChildren } from 'react';
import {
  JobOwnerDetailViewType,
  JobOwnerSummaryViewType,
} from '../types/services-api';
import _orderBy from 'lodash/orderBy';
import { EditJobType } from '../components/job-postings/JobPostingForm';

type JobType = JobOwnerSummaryViewType | JobOwnerDetailViewType | EditJobType;

export type ClipboardContextType = {
  copiedJob?: JobType;
  copyJob: (job: JobType) => void;
  pasteJob: () => void;
};

export const ClipboardContext = React.createContext<ClipboardContextType>({
  copyJob: () => {},
  pasteJob: () => {},
});

const ClipboardContextProvider = (props: PropsWithChildren) => {
  const [copiedJob, setCopiedJob] = useState<JobType>();

  function copyJob(job: JobType) {
    console.log('job copied', job);
    setCopiedJob(job);
  }

  function pasteJob() {
    console.log('job pasted');
    setCopiedJob(undefined);
  }

  ClipboardContext.displayName = 'Job Posting Context';

  return (
    <ClipboardContext.Provider
      value={{
        copiedJob,
        copyJob,
        pasteJob,
      }}
    >
      {props.children}
    </ClipboardContext.Provider>
  );
};

export default ClipboardContextProvider;
